// src/pages/admin/ClientReport.js
import React, { useState, useEffect } from 'react';
import "./AdminClientReport.css";
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import AdminSidebar from './AdminSidebar';
import { useNavigate } from "react-router-dom"; // ⬅️ ADDED for redirect\
import api from "../../api";

function AdminClientReport() {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState({ name: '', email: '' });
  const email = localStorage.getItem("userEmail"); // ⬅️ ADDED get stored email
  const navigate = useNavigate(); // ⬅️ ADDED navigate for redirection

  const [form, setForm] = useState({
    date: '',
    notes: '',
    reportFile: null,
    prescriptionFile: null
  });

  // useEffect(() => {
  //   if (email !== "garishtha.wellness@gmail.com") {
  //     navigate("/profile"); // Redirect non-admin users
  //   }
  // }, [email, navigate]);

  useEffect(() => {
  const fetchUsers = async () => {
    try {
      const res = await api.get("/admin/users");
      console.log(res);
      const data = res.data;   // ✅ use Axios response correctly
      console.log(data);
      setUsers(data);
    } catch (error) {
      console.error("Failed to fetch users:", error);
    }
  };
  fetchUsers();
}, []);

  const handleUserSelect = (e) => {
    const selectedName = e.target.value;
    const user = users.find(u => u.name === selectedName);
    setSelectedUser(user || { name: '', email: '' });
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e, type) => {
    setForm({ ...form, [type]: e.target.files[0] });
  };

  const handleUpload = async () => {
    if (!selectedUser.name) {
      alert("Please select a client.");
      return;
    }

    const formData = new FormData();
    formData.append("full_name", selectedUser.name);
    formData.append("email", selectedUser.email);
    formData.append("date", form.date);
    formData.append("notes", form.notes);
    if (form.reportFile) {
      formData.append("report_file", form.reportFile);
    }
    if (form.prescriptionFile) {
      formData.append("prescription_file", form.prescriptionFile);
    }

    try {
      const response = await api.post("/admin/upload-report", formData, {
  headers: { "Content-Type": "multipart/form-data" },
      });

      alert("Upload successful!");
      console.log("Server response:", response.data);


      if (!response.ok) {
        throw new Error("Failed to upload");
      }

      const result = await response.json();
      alert("Upload successful!");
      console.log("Server response:", result);

      // Clear form
      setSelectedUser({ name: '', email: '' });
      setForm({
        date: '',
        notes: '',
        reportFile: null,
        prescriptionFile: null
      });

    } catch (error) {
      console.error("Upload failed:", error);
      alert("Upload failed. Please try again.");
    }
  };

  return (
    <>
      <Header />
      <div className="admin-layout">
        <AdminSidebar />

        <main className="admin-content">
          <div className="admin-client-report">
            <div className="admin-header">
              <h1 className="upload-text">Upload Report</h1>
              <a
                href="https://1drv.ms/b/c/75d03429d4bc19e1/EeEZvNQpNNAggHWdPAAAAAABYCCBIij92fxiH0121I1oqQ?e=rpI8Se"
                target="_blank"
                rel="noreferrer"
                className="download-btn"
              >
                Download Report
              </a>
            </div>

            <label>Select Patient</label>
            <select value={selectedUser.name} onChange={handleUserSelect}>
              <option value="">-- Select Client --</option>
              {users.map(user => (
                <option key={user.email} value={user.name}>
                  {user.name}
                </option>
              ))}
            </select>

            {selectedUser.email && (
              <>
                <label>Email</label>
                <input value={selectedUser.email} disabled />
              </>
            )}

            <label>Date of Appointment</label>
            <input
              name="date"
              value={form.date}
              onChange={handleChange}
              placeholder="DD/MM/YYYY"
            />

            <label>Report</label>
            <div className="drop-box">
              <input
                type="file"
                onChange={(e) => handleFileChange(e, "reportFile")}
              />
            </div>

            <div className="prescription-section">
              <div className="prescription-header">
                <h1 className="upload-text">Upload Prescription Pad</h1>
                <a
                  href="https://1drv.ms/b/c/75d03429d4bc19e1/EdhxkyCAOMVMmusnQEtDADQBVrulwOt8vbsVXDqoXp-tCA?e=7yoyMk"
                  target="_blank"
                  rel="noreferrer"
                  className="download-btn"
                >
                  Download Prescription
                </a>
              </div>

              <label>Prescription Pad</label>
              <div className="drop-box">
                <input
                  type="file"
                  onChange={(e) => handleFileChange(e, "prescriptionFile")}
                />
              </div>
            </div>

            <label>Other Notes</label>
            <textarea
              name="notes"
              value={form.notes}
              onChange={handleChange}
              placeholder="Take Notes here..."
            />

            <button className="save-btn" onClick={handleUpload}>
              Save Changes
            </button>
          </div>
        </main>
      </div>
      <Footer />
    </>
  );
}

export default AdminClientReport;
